(function(){
    const paymentIntentAction = $('form').data('payment-intent-action');
    const form = $('form');

    const handleResponse = data => {
        if (data.message) {
            let modal = $.modal('Registratie niet mogelijk', data.message).addButton('Ok');
            if (data.buttons) {
                for (let button of data.buttons) {
                    modal.addButton(button.title, ()=>{
                        window.location = button.url;
                    }).show();
                }
            }
            modal.show();
            return false;
        }
        if (data.location) window.location.href = data.location;
        else return true;
    }

    const stripe = Stripe(form.data('stripe-key'));
    const elements = stripe.elements({
        fonts: [{
            cssSrc: 'https://fonts.googleapis.com/css?family=Work+Sans:400,700'
        }],
        locale: $('html').attr('lang')
    });
    const card = elements.create('card', {
        style: {
            base: {
                fontFamily: '"Work Sans",sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '18px',
                iconColor: '#F9D158',
                color: '#F9D158',
                '::placeholder': {
                    color: 'rgba(255, 255, 255, 0.5)'
                }
            },
            invalid: {
                color: '#F95858',
                iconColor: '#F95858'
            }
        }
    });
    card.mount('#card-element');
    card.addEventListener('change', event => {
        $('#card-errors').text(event.error ? event.error.message : '');
    });

    $('#part-2 a.back').on('click', event => {
        $(document.body).removeClass('part-2').addClass('part-1');
        event.preventDefault();
        return false;
    });

    $('#part-1 button.next').on('click', event => {
        if (event.which == 1) {
            if (validateForm($('#part-1')) !== false) {
                $(event.target).ajaxBusy();
                $.ajax({
                    type: 'POST',
                    url: paymentIntentAction,
                    data: form.serialize(),
                    dataType: 'json',
                    success: data => {
                        if (handleResponse(data) === true) {
                            $(event.target).ajaxDone(data.success);
                            $(document.body).addClass('part-2').removeClass('part-1').toggleClass('free', data.free);
                        } else {
                            $(event.target).ajaxDone(false);
                        }
                    }
                });
            }
        }
    });

    const submitForm = function (sourceID) {
        let data = form.serializeArray();
        data.push({ name: 'source_id', value: sourceID});
        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: data,
            dataType: 'json',
            success: data => {
                if (data.message) {
                    let modal = $.modal('Registratie mislukt', data.message).addButton('Ok');
                    if (data.buttons) {
                        for (let button of data.buttons) {
                            modal.addButton(button.title, ()=>{
                                window.location = button.url;
                            }).show();
                        }
                    }
                    modal.show();
                }
                if (data.location) window.location.href = data.location;
                else form.find('input[type="submit"],button[type="submit"]').ajaxDone(data.success);
            }
        });
    }

    form.on('submit', event => {
        event.preventDefault();
        if (validateForm($('#part-2')) !== false) {
            form.find('input[type="submit"],button[type="submit"]').ajaxBusy();
            if (!$(document.body).hasClass('free')) {
                stripe.createSource(card, {
                    owner: {
                        name: $('input[name="firstname"]').val() + ' ' + $('input[name="lastname"]').val(),
                        email: $('input[name="email"]').val()
                    }
                }).then(function(result) {
                    if (result.error) {
                        $.modal('Betaling mislukt', result.error.message).addButton('Ok').show();
                        form.find('input[type="submit"],button[type="submit"]').ajaxDone(false);
                    } else if (result.source) {
                        submitForm(result.source.id);
                    } else {
                        $.modal('Betaling mislukt', 'Er trad een onbekende fout op bij het verwerken van uw betaling.').addButton('Ok').show();
                        form.find('input[type="submit"],button[type="submit"]').ajaxDone(false);
                    }
                });
            } else {
                submitForm();
            }
        }
    });
})();
